import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import ImageNoize from './components/ImageNoize.vue'

Vue.config.productionTip = false

new Vue({
  router: router,
  vuetify,
  render: h => h(App),
  components: {
    'image-noize':ImageNoize
  }
}).$mount('#app')
